module.exports = __webpack_public_path__ + "static/media/image_2.c296e5ea.jpg";